import { QRCodeSVG } from 'qrcode.react';

/**
 * OTP 앱 등록 정보 — QR(otpauth:// URI)과 수동 입력 키.
 * 로그인 화면의 첫 등록과 보안 설정 화면의 내 OTP 등록이 같이 쓴다.
 */
export function OtpEnrollment({ secret, otpauthUrl }: { secret: string; otpauthUrl: string }) {
  return (
    <div className="flex flex-wrap items-start gap-4">
      {/* QR 은 어두운 화면에서도 읽히게 흰 바탕 위에 */}
      <div className="shrink-0 rounded-md bg-white p-2">
        <QRCodeSVG value={otpauthUrl} size={144} marginSize={0} title="OTP 등록 QR 코드" />
      </div>
      <div className="min-w-0 flex-1 space-y-1.5 text-sm">
        <p className="text-muted-foreground">
          Google Authenticator 등 OTP 앱으로 QR 을 찍어 주세요. 찍을 수 없으면 아래 키를 직접
          입력해요.
        </p>
        <p className="break-all rounded-md bg-muted/60 px-2.5 py-2 font-mono text-xs tracking-wider">
          {secret}
        </p>
      </div>
    </div>
  );
}
